module.exports = __webpack_public_path__ + "assets/f707272f87005365f11d2d08b4b7625b.png";